import * as React from 'react';

const ReactQueryDevtools = React.lazy(async () => {
	const module = await import('@tanstack/react-query-devtools');
	return { default: module.ReactQueryDevtools };
});

export default function DevQueryTools() {
	if (!import.meta.env.DEV) {
		return null;
	}

	return (
		<React.Suspense fallback={null}>
			<ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
		</React.Suspense>
	);
}
